import React, { ReactNode } from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import Sidebar from "src/components/layouts/sidebar/Sidebar";
import Breadcrumb from "src/components/layouts/Common/Breadcrumb";
import Teachers from "src/components/panel/teachers/Teachers";

const TeachersView: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>{t("teachers_list_view")}</title>
      </Helmet>
      <Sidebar>
        <Breadcrumb title={t("teachers_list_title")} 
        subtitle={t("teachers_list_subtitle")}/>
        <Teachers/>
      </Sidebar>
    </>
  );
};

export default TeachersView;